import { jwtDecode } from "jwt-decode";
import { Navigate, Outlet } from "react-router-dom";

const verificarTokenExpirado = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp * 1000;
  } catch (error) {
    return true;
  }
};

const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  if (!token || verificarTokenExpirado(token)) {
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }

  const userRole = localStorage.getItem("role");

  // Se a rota exigir uma role específica, verifica se o usuário tem permissão
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/" replace />;
  }

  return children ? children : <Outlet />;
};

export default PrivateRoute;
